<template>
  <component
    :is="tag"
    v-font="fontDirective"
    class="t-title leading-none subpixel-antialiased tracking-normal"
    :class="[
      SizeClasses[size],
      responsive ? SizeResponsiveClasses[size] : '',
      color,
      classes,
      LeadingClasses[leading],
    ]"
    :critical="critical ? true : null"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import {
  titleFont,
  weightRegular,
  weightBold,
} from '~~/modules/design-system/utils/booster-config/fonts'

import {
  SizeClasses,
  SizeResponsiveClasses,
  LeadingClasses,
} from './constants/constants'

export interface propsInterface {
  tag?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
  responsive?: boolean
  color?: string
  classes?: string
  bold?: boolean
  critical?: boolean
  leading?: 'none' | 'tight'
}

const props = withDefaults(defineProps<propsInterface>(), {
  tag: 'div',
  size: 'lg',
  responsive: true,
  color: 'text-gray-900',
  classes: 'mb-4',
  bold: false,
  critical: false,
  leading: 'none',
})

const { $getFont } = useBoosterFonts({ critical: true })

const fontDirective = $getFont(
  titleFont,
  props.bold ? weightBold : weightRegular,
)
</script>
